import React from "react"
import Login from "../components/DTLogin"

const Page = () => {
  return <Login />
}

export default Page
